export const DEFAULT_MIME_TYPE = 'application/octet-stream';
